/*
Copyright (c) 2012-2025 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/

import React, { FC } from "react"
import { Button } from "@duxton-web/ui"
import { useTranslation } from "common/utils/i18n"
import { SerializedError } from "@reduxjs/toolkit"
import { FetchBaseQueryError } from "@reduxjs/toolkit/query"
import styles from "./MenuPartialError.modules.css"

interface IProps {
  error?: FetchBaseQueryError | SerializedError
  onRefetch: () => void
}

export const MenuPartialError: FC<IProps> = ({ error, onRefetch }: IProps) => {
  const defaultErrorMsg = useTranslation("common.error")

  // Extract error message from API error response
  const getErrorMessage = () => {
    if (!error) return defaultErrorMsg

    // RTK Query FetchBaseQueryError structure
    if ("data" in error && error.data) {
      const errorData = error.data as { message?: string }
      if (errorData?.message) {
        return errorData.message
      }
    }

    // SerializedError or other error types
    if ("message" in error && error.message) {
      return error.message
    }

    return defaultErrorMsg
  }

  return (
    <div className={styles.errorContainer}>
      <div className={styles.errorMessage}>{getErrorMessage()}</div>
      <Button
        type="default"
        onClick={onRefetch}
        className={styles.refetchButton}
      >
        Retry
      </Button>
    </div>
  )
}
